import React from "react";

export default function DeleteIcon({ color = "#c8c8c8" }) {
  return (
    <svg width="19" height="19" viewBox="0 0 19 19">
      <g stroke={color} strokeWidth="4">
        <line x1="3" y1="3" x2="16" y2="16" />
        <line x1="3" y2="3" y1="16" x2="16" />
      </g>
    </svg>
  );
}
